<template>
  <div class="z-hard">

    <transition
      enter-active-class="animate__animated animate__fadeInLeft animate__fast"
      leave-active-class="animate__animated animate__fadeOutRight animate__fast"
    >
      <div
        class="flex flex-col side-packages z-hard shadow-2xl jcs overflow-hidden"
        v-if="showPackage"
      >
        <button
          class="flex items-center justify-between py-2 lg:py-4 px-4 w-full bg-gray"
          @click="$emit('close')"
        >
          <span class="text-black pl-4 text-sm nunito-semibold">{{$t('Add additional items')}}</span>
          <div class="flex aic jcc w-40p h-40p transform scale-75">
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M2.117 12l7.527 6.235-.644.765-9-7.521 9-7.479.645.764-7.529 6.236h21.884v1h-21.883z"/></svg>
          </div>
        </button>

        <div class="w-full pck-img flex aic jcb p-7 h-40">
            <img
              :src="product.image ? storageUrl + product.image : '/dish.webp'"
              class="h-20 md:h-24 object-cover"
            />
            <div class="flex flex-col aie jcb w-full space-y-2">
              <h2 class="nunito-bold text-gray-700 capitalize">{{ product.name }}</h2>
              <span class="text-gray-500 text-sm nunito-bold">{{ currency }} {{ product.price }}</span>
            </div>

        </div>

        <transition
          enter-active-class="animate__animated animate__fadeIn animate__faster"
          leave-active-class="animate__animated animate__fadeOut animate__faster"
        >
          <div v-if="alertDialog" class="absolute bottom-28 left-0 z-50 w-full">
            <div class="bg-yellow-50 p-4 pck-msg mx-auto border-l-4 border-yellow-500">
              <div class="flex">
                <i class="fa fa-exclamation-triangle text-yellow-500"></i>
                <div class="ml-3">
                  <p class="text-xs lg:text-sm text-yellow-700">
                    {{msg}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </transition>
          <attributes
            :attributes="attributes"
            v-if="type == 'attributes'"
            :currency="currency"
            :storageUrl="storageUrl"
            :product="product"
            @close="attrClose()"
          ></attributes>
          <packages
            v-if="type == 'package'"
            :currency="currency"
            :storageUrl="storageUrl"
            :product="product"
            @close="attrClose()"
            @showAlertDialog="ShowAlertDialog"
          ></packages>
      </div>
    </transition>
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__fast"
      leave-active-class="animate__animated animate__fadeOut animate__fast"
    >
      <div
        class="packages-overlay"
        v-if="showPackage"
        @click="$emit('close')"
      ></div>
    </transition>
    <SideCart
      @closeCard="showCart = false"
      :showCart="showCart"
    ></SideCart>
  </div>
</template>
<script>
import SideCart from "./SideCart.vue";

import Attributes from "./Attributes.vue";
import Packages from "./Packages.vue";
export default {
  components: { Attributes, Packages, SideCart },
  name: "extraProducts",
  props: [
    "showPackage",
    "product",
    "storageUrl",
    "currency",
    "attributes",
    "type",
  ],
  data(){
    return {
      showCart: false,
      alertDialog:false,
      msg:""
    }
  },
  methods:{
    attrClose() {
      this.$emit("close");
      this.showCart = true
    },
    ShowAlertDialog(msg){
      this.alertDialog = true;
      this.msg = msg;
      setTimeout(()=>{
        this.alertDialog = false;
      },2000)
    }
  }
};
</script>
